import {
   MedicineSimilar,
   PatientContinuouslyUsedMedicineExtended,
   PatientMedicine,
} from '@dreryk/egabinet-prescription-frontend-api';

import { Props, useEffect } from '~libs.ui.react';

import { useMedicineSafetyIndicatorsConfigMapGlobalState } from '../shared/useMedicineSafetyIndicatorsConfigMapGlobalState';
import { MedicineId, MedicineSafetyIndicatorConfig, MedicineSafetyIndicatorType } from '../types';

import { mapMedicineSimpleToMedicineSafetyIndicatorsConfig } from './MedicineSafetyIndicatorsConfigResolver.utils';

type MedicineSafetyIndicatorsConfigResolverProps = Props<{
   medicines: Array<PatientMedicine | PatientContinuouslyUsedMedicineExtended | MedicineSimilar>;
}>;

export const MedicineSafetyIndicatorsConfigResolver = (props: MedicineSafetyIndicatorsConfigResolverProps): null => {
   const [, setMedicineSafetyIndicatorsConfigMap] = useMedicineSafetyIndicatorsConfigMapGlobalState();

   useEffect(() => {
      const nextMedicineSafetyIndicatorsMap = props.medicines.reduce((configMap, medicine) => {
         const medicineSimple = 'medicine' in medicine ? medicine.medicine : medicine.patientMedicine.medicine;
         configMap.set(medicineSimple.id, mapMedicineSimpleToMedicineSafetyIndicatorsConfig(medicineSimple));
         return configMap;
      }, new Map<MedicineId, Record<MedicineSafetyIndicatorType, MedicineSafetyIndicatorConfig>>());

      setMedicineSafetyIndicatorsConfigMap(
         (previousMedicineSafetyIndicatorsMap) =>
            new Map([...previousMedicineSafetyIndicatorsMap, ...nextMedicineSafetyIndicatorsMap])
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.medicines]);

   return null;
};
